import { eventBus } from '../eventBus';

export enum AlertDialogAction {
  FIRE = 'alertDialog/FIRE',
  CLOSE = 'alertDialog/CLOSE',
}

export type AlertDialogOption = {
  title: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
};

export type AlertDialogResult = {
  isConfirmed: boolean;
};

export const fire = (message: string | AlertDialogOption, options?: Partial<AlertDialogOption>) => {
  if (typeof message === 'string') {
    const { description, ...restOptions } = options || {};
    return eventBus.asyncDispatch<AlertDialogResult>(AlertDialogAction.FIRE, {
      title: message,
      description,
      ...restOptions,
    });
  }
  return eventBus.asyncDispatch<AlertDialogResult>(AlertDialogAction.FIRE, {
    ...message,
  });
};

export const close = () => {
  return eventBus.asyncDispatch(AlertDialogAction.CLOSE);
};
